import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getAllEmotionEpisodeContentTags } from '../../../api/actions/emotion-episode-content-tag/emotion-episode-content-tag-get-all';
import { AddBreadcrumbsItem } from '../../../components/shared/breadcrumbs/breadcrumbs';
import { Button } from '../../../components/shared/button/button';
import { Grid } from '../../../components/shared/grid/grid';
import { LinkButton } from '../../../components/shared/link-button/link-button';
import { Loader } from '../../../components/shared/loader/loader';
import { compareText } from '../../../helpers/array-helpers';
import { basePerformError } from '../../../helpers/error-helpers';
import { joinPath } from '../../../helpers/path-helpers';
import { IEmotionEpisodeContentTag } from '../../../models/emotion-episode-content-tag';
import styles from './emotion-episode-content-tags-list.module.scss';


export function EmotionEpisodeContentTagsList(props: RouteComponentProps) {
    const [loading, setLoading] = useState(true);
    const [tags, setTags] = useState<IEmotionEpisodeContentTag[]>([]);

    const loadData = React.useCallback(async () => {
        setLoading(true);
        try {
            setTags((await getAllEmotionEpisodeContentTags()).sort((el1, el2) => compareText(el1, el2, (el) => el.name)))
        }
        catch(err) {
            basePerformError(err, props.history);
        }
        setLoading(false);
    }, [props.history]);

    useEffect(() => {
        loadData().catch(() =>{/** */});
    }, [loadData]);

    const renderButtons = () => (
        <div className={styles.buttons}>
            <Button className="orange" to={joinPath(props.match.url, '_')}>Add Tag</Button>
        </div>
    );

    return loading ? (<Loader />) : (<>
        <AddBreadcrumbsItem
            title={'Emotion Episode Content Tags'}
            url={props.match.url}
        />

        

        <Grid<IEmotionEpisodeContentTag>
            disablePaging={true}

            getPageData={(page) => {
                return Promise.resolve({
                    page,
                    count: tags?.length || 0,
                    data: tags,
                });
            }}

            containerRenderer={(content, pager) => (<>
                <div className={styles.pager}>{pager} {renderButtons()}</div>
                <table cellPadding="0" cellSpacing="0" className={`list ${styles.list}`}>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Tag Type</th>
                            <th>Actions</th>
                        </tr>
                        {content}
                    </tbody>
                </table>
                <div className={styles.pager}>{pager}</div>
            </>)}

            itemRenderer={(contentTag, i) => (
                <tr key={contentTag.uid}>
                    <td>
                        {i + 1}
                    </td>
                    <td>
                        {contentTag.name}
                    </td>
                    <td>
                        {contentTag.tagType}
                    </td>
                    <td>
                        <LinkButton to={joinPath(props.match.url, contentTag.uid)}>
                            <FontAwesomeIcon icon={faEdit} /> Edit
                        </LinkButton>
                    </td>
                </tr>
            )}
        />

        {renderButtons()}
    </>);
}